import type { UserRoles } from "~enums/userRoles";
import type { UserStatuses } from "../enums/userStatuses";
import type { UserTransformed } from "../types";

const filterUsers = (
  users: UserTransformed[],
  searchText: string,
  roles: Set<UserRoles>,
  status: UserStatuses | undefined,
): UserTransformed[] =>
  users.filter((user) => {
    if (status && user.status !== status) {
      return false;
    }
    if (roles.size > 0 && !roles.intersection(user.userRolesSet).size) {
      return false;
    }
    if (searchText) {
      const searchTextLower = searchText.toLowerCase();
      if (!user.name.toLowerCase().includes(searchTextLower) && !user.email.toLowerCase().includes(searchTextLower)) {
        return false;
      }
    }
    return true;
  });

export default filterUsers;
